document.addEventListener('DOMContentLoaded', () => {
  const scrollAreas = document.querySelectorAll('.scroll-area.is-scrollable');

  scrollAreas.forEach(scrollArea => {
    const prevButton = scrollArea.parentElement.querySelector('button[is="prev-button"]');
    const nextButton = scrollArea.parentElement.querySelector('button[is="next-button"]');
    const items = scrollArea.querySelectorAll('.multi-column__item.snap-start');

    // Log for debugging
    console.log('scrollArea:', scrollArea);
    console.log('prevButton:', prevButton);
    console.log('nextButton:', nextButton);

    const updateButtonStates = () => {
      const scrollLeft = scrollArea.scrollLeft;
      const maxScroll = scrollArea.scrollWidth - scrollArea.clientWidth;

      if (prevButton) prevButton.disabled = scrollLeft <= 0;
      if (nextButton) nextButton.disabled = scrollLeft >= maxScroll - 1;
    };

    const scrollToNextItem = () => {
      let closestItem = null;
      let closestDistance = Infinity;

      items.forEach(item => {
        const itemLeft = item.offsetLeft;
        const currentScroll = scrollArea.scrollLeft;

        if (itemLeft > currentScroll + 1) {
          const distance = itemLeft - currentScroll;
          if (distance < closestDistance) {
            closestDistance = distance;
            closestItem = item;
          }
        }
      });

      if (closestItem) {
        scrollArea.scrollTo({
          left: closestItem.offsetLeft,
          behavior: 'smooth'
        });
      }
    };

    const scrollToPrevItem = () => {
      let closestItem = null;
      let closestDistance = Infinity;

      items.forEach(item => {
        const itemLeft = item.offsetLeft;
        const currentScroll = scrollArea.scrollLeft;

        if (itemLeft < currentScroll - 1) {
          const distance = currentScroll - itemLeft;
          if (distance < closestDistance) {
            closestDistance = distance;
            closestItem = item;
          }
        }
      });

      if (closestItem) {
        scrollArea.scrollTo({
          left: closestItem.offsetLeft,
          behavior: 'smooth'
        });
      }
    };

    if (prevButton) {
      prevButton.addEventListener('click', scrollToPrevItem);
    } else {
      console.warn('Previous button not found for scroll area:', scrollArea);
    }

    if (nextButton) {
      nextButton.addEventListener('click', scrollToNextItem);
    } else {
      console.warn('Next button not found for scroll area:', scrollArea);
    }

    scrollArea.addEventListener('scroll', updateButtonStates);
    updateButtonStates();
  });
});